import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetMainNewsActionType {
  Reset = 'mainNews/resetMainNews',
}

export type TResetMainNews = ITypedReduxAction<EResetMainNewsActionType.Reset>;
